import React from 'react';

interface DividerProps {
  className?: string;
}

const Divider: React.FC<DividerProps> = ({ className = '' }) => (
  <div className={`h-[2px] w-full space-y-7 bg-[#f2f2f2] ${className}`} />
);

export default Divider;
